(ns teamoesterreich.admin-mode.crowdtasker.task.task-region
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [goog.json :as json]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.eventTask :as d-eventTask]
            [teamoesterreich.admin-mode.map.map-polygon-picker :as map-polygon-picker]


            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]

            [clojure.string :as string]))

(defn un-serialize-path [in]
  (json/parse in))


(defn radio [name !radio ]
  [mui/form-control-label {:label name :value "dst" :placement "start"
                           :control (r/as-element [mui/radio {:checked @!radio
                                                              :onChange (fn [val] )
                                                              }])}]

  )



(defn region-selector []
  (let [!st (r/atom {:region-type nil :path #js [] :district nil :state nil  })
        !event-task (r/cursor v-state/app-state [:selected-task])
        !region-type (r/cursor !st [:region-type])
        !district (r/cursor !st [:district])
        !state (r/cursor !st [:state])
        !path (r/cursor !st [:path])]
    (fn []
      (let [

            reset-fn (fn [] (reset! !st {:region-type nil :path #js [] :district nil :state nil }))

            initial-path (if (and (:crowdtaskerTask-locationPolygonJsonString @!event-task) (not= (:crowdtaskerTask-locationPolygonJsonString @!event-task) ""))
                           (un-serialize-path (:crowdtaskerTask-locationPolygonJsonString @!event-task))
                           #js [])


            g-state (:crowdtaskerTask-locationState @!event-task)
            g-district (:crowdtaskerTask-locationDistrict @!event-task)

            g-type (cond
                     (and initial-path (not-empty initial-path)) :polygon
                     (and g-district (not= "" g-district)) :district
                     (and g-state (not= "" g-state)) :state
                     :else :none)

            changed? (or (and @!region-type (not= g-type @!region-type))
                         (and @!district (not= g-district @!district))
                         (and @!state (not= g-state @!state)))
            ]
        (log/debug "g-type " (clj->js g-type) initial-path)
        [mui/paper
         {:style {:textAlign "left" :padding "10px"}}
         [mui/form-control {:component "fieldset"}
          [mui/radio-group {:row           true
                            :style {:float "left" :padding "10px" :backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                            :value (or @!region-type g-type)
                            :onChange (fn [e] (reset! !region-type (keyword (h/event-value e))))
                            }
           [mui/form-control-label
            {:value :none
             :style {:width "300px"}
             :control (r/as-element [mui/radio { :color "primary" }])
             :label (str "Keine Region" )
             }
            ]
           [mui/form-control-label
            {:value :state
             :style {:width "300px"}
             :control (r/as-element [mui/radio { :color "primary"}])
             :label (str "Kreis" )
             }
            ]
           [mui/form-control-label
            {:value :district
             :style {:width "300px"}
             :control (r/as-element [mui/radio { :color "primary"}])
             :label (str "Gemeinde" )
             }
            ]
           [mui/form-control-label
            {:value :polygon
             :style {:width "300px"}
             :control (r/as-element [mui/radio { :color "primary"}])
             :label (str "Polygon" )
             }
            ]

           ]]

         [:br ]
         (case (or @!region-type g-type)
           :none [:div {:style {:padding "7px 0 7px 0"}}
                  [mui/chip {:label "Keine Regions-Eingrenzung"}]
                  [:br ][:br ]
                  (when changed?
                    [mui/button {:variant   "contained"
                                 :startIcon (r/as-element [keyboard-arrow-left])
                                 :onClick   reset-fn
                                 } "Abbrechen"])
                  (when changed?
                    [mui/button {:variant   "contained"
                                 :style {:marginLeft "20px"}
                                 :color     "primary"
                                 :onClick (fn [] (d-eventTask/>task-save-county-state (:crowdtaskerTask-uuid @!event-task) nil nil #(reset! !event-task %)))
                                 :startIcon (r/as-element [save])}
                     "Speichern"])
                  ]

           :polygon [:div {:style {:padding "7px 0 7px 0"}}
                     [map-polygon-picker/pick-polygon-gmap-component !st initial-path]
                     ;[map-polygon-picker/pick-polygon-test]
                     [:br ][:br ]

                     (when changed?
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [keyboard-arrow-left])
                                    :onClick reset-fn
                                    } "Abbrechen"])

                     [mui/button {:variant   "contained"
                                  :startIcon (r/as-element [edit])
                                  :style {:marginLeft "20px"}
                                  :onClick #(swap! !st assoc :pickMode true :path #js [])
                                  } "Polygon beginnen"]
                     (js/console.log "Polygon: " @!st)
                     (when true ;(and changed? (> (count (:path @!st)) 2))
                       [mui/button {:variant   "contained"
                                    :style {:marginLeft "20px"}
                                    :color     "primary"
                                    :onClick (fn []
                                               (when (> (count (:path @!st)) 2)
                                                 (d-eventTask/>task-save-polygon (:crowdtaskerTask-uuid @!event-task) @!path #(reset! !event-task %))))
                                    :startIcon (r/as-element [save])}
                        (str "Speichern")])]


           :state [:div {:style {:padding "7px 0 7px 0"}}
                   [:br ]
                   [mui/form-control
                    {
                     :fullWidth true
                     }
                    [mui/input-label "Bezirk"]

                    [mui/select {:style {:width "300px" :backgroundColor (if (and @!state (not= g-state @!state)) "#ffd6d2" "#ffffff")}
                                 :value (or @!state g-state "")
                                 :onChange (fn [e] (reset! !state (keyword (h/event-value e))))
                                 }
                     [mui/menu-item {:key "DISTRICT-NONE" :value "" } "---"]
                     (for [[k v] (sort-by first (txt/txt :fake :districts))]
                       ^{:key (str "DISTRICT-" k)} [mui/menu-item {:key (str "" k) :value k } v])
                     ]
                    ]
                   [:br ]
                   [:br ]
                   (when changed?
                     [mui/button {:variant   "contained"
                                  :startIcon (r/as-element [keyboard-arrow-left])
                                  :onClick reset-fn
                                  } "Abbrechen"])
                   (when changed?
                     [mui/button {:variant   "contained"
                                  :style {:marginLeft "20px"}
                                  :color     "primary"
                                  :onClick (fn [] (d-eventTask/>task-save-county-state (:crowdtaskerTask-uuid @!event-task) @!state nil #(reset! !event-task %)))
                                  :startIcon (r/as-element [save])}
                      "Speichern"])
                   ]

           :district [:div {:style {:padding "7px 0 7px 0"}}
                      [:br ]
                      [mui/form-control
                       {
                        :fullWidth false
                        }
                       [mui/input-label "Bezirk"]

                       [mui/select {:style {:width "300px" :backgroundColor (if (and @!state (not= g-state @!state)) "#ffd6d2" "#ffffff")}
                                    :fullWidth false
                                    :value (or @!state g-state "")
                                    :onChange (fn [e] (reset! !state (h/event-value e)))
                                    }
                        [mui/menu-item {:key "DISTRICT-NONE" :value "" } "---"]
                        (for [[k v] (sort-by first (txt/txt :fake :districts))]
                          ^{:key (str "DISTRICT-" k)} [mui/menu-item {:key (str "" k) :value k } v])
                        ]
                       ]
                      (when (or @!state g-state)
                        [mui/form-control
                         {:style {:marginLeft "30px"}
                          :fullWidth false
                          }
                         [mui/input-label "Kreis"]

                         [mui/select {:style {:width "300px" :backgroundColor (if (and @!state (not= g-district @!district)) "#ffd6d2" "#ffffff")}
                                      :fullWidth false
                                      :value (or @!district g-district "")
                                      :onChange (fn [e] (reset! !district (h/event-value e)))
                                      }
                          [mui/menu-item {:key "COUNTY-NONE" :value "" } "---"]
                          (for [[k v] (filter
                                        #(string/starts-with? (first %) (or @!state g-state))
                                        (sort-by first (txt/txt :fake :county)))]
                            ^{:key (str "COUNTY-" k)} [mui/menu-item {:key (str "" k) :value k } v])
                          ]

                         ])
                      [:br ]
                      [:br ]
                      (when changed?
                        [mui/button {:variant   "contained"
                                     :startIcon (r/as-element [keyboard-arrow-left])
                                     :onClick reset-fn
                                     } "Abbrechen"])
                      (when changed?
                        [mui/button {:variant   "contained"
                                     :style {:marginLeft "20px"}
                                     :color     "primary"
                                     :onClick (fn [] (d-eventTask/>task-save-county-state (:crowdtaskerTask-uuid @!event-task) @!state @!district #(reset! !event-task %)))
                                     :startIcon (r/as-element [save])}
                         "Speichern"])
                      ]
           ""
           )
         ]

        ))))












































